import AstroStaticPage from "@/common/components/AstroStaticPage";
import React from "react";
import { Data } from "./data";

const Vastu = () => {
  return <AstroStaticPage data={Data} />;
};

export default Vastu;
